/*
Generated time: March 11, 2025 03:28
This file was created by the app developer. Feel free to contact the original developer with any questions. It was minified (compressed) by AVADA. AVADA do NOT own this script.
*/

function mainRender() {
  document.addEventListener("DOMContentLoaded",()=>{
    // Set initial zoom based on viewport width
    $("#root").css("zoom", "normal");
    var zoomRatio = document.body.clientWidth / 1080;
    $("#root").css("zoom", zoomRatio);
    
    // Handle window resize events
    window.addEventListener("resize", function() {
      resizeTimeout && clearTimeout(resizeTimeout);
      resizeTimeout = setTimeout(function() {
        $("#root").css("zoom", "normal");
        var zoomRatio = document.body.clientWidth / 1080;
        $("#root").css("zoom", zoomRatio);
      }, 100);
    });
  });

  document.addEventListener("DOMContentLoaded", function() {
    // Lazy loading for images
    var lazyImages = document.querySelectorAll(".lazy-load");
    let lazyImageObserver = new IntersectionObserver(
      function(entries, observer) {
        entries.forEach(function(entry) {
          if (entry.isIntersecting) {
            var imageSrc = entry.target.getAttribute("data-src");
            entry.target.src = imageSrc;
            lazyImageObserver.unobserve(entry.target);
          }
        });
      },
      { rootMargin: "0px 0px 1300px 0px", threshold: 0 }
    );
    
    lazyImages.forEach(function(image) {
      lazyImageObserver.observe(image);
    });

    // Smooth scrolling for anchor links
    document.querySelectorAll('a[href^="#"]').forEach(function(anchor) {
      anchor.addEventListener("click", function(event) {
        event.preventDefault();
        var targetElement = document.getElementById("shopping");
        targetElement && targetElement.scrollIntoView({ behavior: "smooth" });
      });
    });
  });

  // Device detection
  var userAgent = navigator.userAgent || navigator.vendor || window.opera;
  var isAndroid = /android/i.test(userAgent);
  var isIOS = /iPad|iPhone|iPod/.test(userAgent) && !/MSStream/.test(userAgent) && !/ZhanFu/.test(userAgent);
  var isPC = !(isAndroid || isIOS || /Iron/.test(userAgent) || /ZhanFu/.test(userAgent));
  
  if (isAndroid) {
    console.log("Android");
  } else if (isIOS) {
    console.log("iOS");
    $(".sp_system").css("letter-spacing", "-2px");
  } else if (isPC) {
    console.log("PC");
  } else {
    console.log("Unknown Device");
    $(".sp_system").css("letter-spacing", "-4px");
  }

  $(function() {
    let products = window.product;
    
    // Initialize alignment functions
    alignmentFns.initialize();
    
    // Product 2 quantity change handler
    $("#2").change(function() {
      var quantity = Number($("#2").val());
      var product = products[0];
      
      $(this).parents().siblings(".sp-price").children().children(".new").html(
        (quantity * Number(product.price) / 100).toFixed(2)
      );
      
      $(this).parents().siblings(".sp-price").children().children(".old").html(
        (quantity * Number(product.compare_at_price) / 100).toFixed(2)
      );
      
      $(this).parents().siblings(".sp-texts").children(".save-text").html(
        (quantity * Number(product.compare_at_price - product.price) / 100).toFixed(2)
      );
    });
    
    // Product 3 quantity change handler
    $("#3").change(function() {
      var quantity = Number($("#3").val());
      var product = products[1];
      
      $(this).parents().siblings(".sp-price").children().children(".new").html(
        (quantity * Number(product.price) / 100).toFixed(2)
      );
      
      $(this).parents().siblings(".sp-price").children().children(".old").html(
        (quantity * Number(product.compare_at_price) / 100).toFixed(2)
      );
      
      $(this).parents().siblings(".sp-texts").children(".save-text").html(
        (quantity * product.price / 300).toFixed(2)
      );
    });
    
    // Product 4 quantity change handler
    $("#4").change(function() {
      var quantity = Number($("#4").val());
      var product = products[2];
      
      $(this).parents().siblings(".sp-price").children().children(".new").html(
        (quantity * Number(product.price) / 100).toFixed(2)
      );
      
      $(this).parents().siblings(".sp-price").children().children(".old").html(
        (quantity * Number(product.compare_at_price) / 100).toFixed(2)
      );
      
      $(this).parents().siblings(".sp-texts").children(".save-text").html(
        (quantity * product.price / 500).toFixed(2)
      );
    });
    
    // Product 5 quantity change handler
    $("#5").change(function() {
      var quantity = Number($("#5").val());
      var product = products[3];
      
      $(this).parents().siblings(".sp-price").children().children(".new").html(
        (quantity * Number(product.price) / 100).toFixed(2)
      );
      
      $(this).parents().siblings(".sp-price").children().children(".old").html(
        (quantity * Number(product.compare_at_price) / 100).toFixed(2)
      );
      
      $(this).parents().siblings(".sp-texts").children(".save-text").html(
        (quantity * product.price / 1000).toFixed(2)
      );
    });
    
    // Image carousel functionality
    $("#goods-image_header_1").show();
    $("#goods-image_header_2").hide();
    var showFirstImage = true;
    
    setInterval(() => {
      showFirstImage = !showFirstImage;
      if (showFirstImage) {
        $("#goods-image_header_1").show();
        $("#goods-image_header_2").hide();
      } else {
        $("#goods-image_header_1").hide();
        $("#goods-image_header_2").show();
      }
    }, 1000);
    
    // Buy now button click handler
    $(".buyNow").click(function() {
      var productId = $(this).attr("data-id");
      var quantity = $(this).siblings(".sp-number").find("input").val();
      window.location.href = "/cart/" + productId + ":" + quantity;
    });
    // 弹窗 start
  //  var main_id = "";
  //  var num = ''
  //   $('.emitCheckout').click(function(){
  //     console.log('1111')
  //     main_id = $(this).attr("data-id");
  //     num = quantity = $(this).siblings(".sp-number").find("input").val();
  //     // main_id = $(this).siblings('.select_span').find('span.on').data('id')
  //     // window.location.href = "/cart/" + id + ":1"
  //   })

  // function getPopProdId(){
  //   let selectVals = [];
  //  $('.overbuy_wrap .sp-subopt.active').each(function(){
  //     selectVals.push($(this).data('val'))
  //   })

  //   let cur = popProduct.filter(item => {
  //     let option1 = selectVals[0];
  //     let option2 = null;
  //     let option3 = null;
  //     if(selectVals[1]){
  //       option2 = selectVals[1];
  //     }
  //     if(selectVals[2]){
  //       option3 = selectVals[2];
  //     }

      
  //     return item.option1 == option1 && item.option2 == option2 && item.option3 == option3
  //   })

 
    
  //   return cur[0];
  // }

  // $('.overbuy-select div').click(function(){
  //    $(this).siblings().removeClass('active')
  //    $(this).addClass('active')
  //   let cur = getPopProdId();
    
  //   if(cur){
  //     $(".main-btn").text('GET 10% oFF').removeClass("overbuy_disabled")
  //     let _price = parseFloat(cur.price / 100).toFixed(2);
  //     let _compare_at_price = parseFloat(cur.compare_at_price / 100).toFixed(2);
  
  //     $('.overbuy_price span').eq(0).html('$' + _price);
  //     $('.overbuy_price span').eq(1).html('$' + _compare_at_price);
  //   }else{
  //     $(".main-btn").text("Unavailable").addClass("overbuy_disabled")
  //   }
    
  // })

  


  // window.emitSubmit = function(_type){

  //    if(_type == 'all'){
  //     // var bundle_sku = data[$('input[name="overbuy1"]:checked').val()][$('input[name="overbuy2"]:checked').val()]
  //     let _id = getPopProdId()?.id;
  //      if(!_id) return
  //     console.log(_id)
       
  //     window.location.href = `/cart/${main_id}:${num},${_id}:1`
  //   }else{
  //     window.location.href = `/cart/${main_id}:${num}`
  //   }
  // }



  // 弹窗 end
    // Logo click handler
    $(".logo").click(function() {
      window.location.href = "https://toretark.com/";
    });
  });
}

mainRender();